module.exports = __webpack_public_path__ + "static/media/logo_circle_dark.7ce53e80.png";